<template>
  <div class="agenda-viewer">
    <v-card :loading="loading" tile style="height: auto !important">
      <v-card-title v-if="showTitle">
        <v-spacer></v-spacer>Agenda<v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="ml-2"
          @click="ferieDialog = true"
          :disabled="loading"
        >
          Richiedi permesso
        </v-btn>
      </v-card-title>

      <v-card-text v-if="orderedDays.length === 0">
        Nessun evento da mostrare
      </v-card-text>

      <v-card-text v-if="orderedDays.length > 0">
        <div v-for="day in orderedDays" :key="day.text" class="day">
          <h2 class="day-text">{{ day.text }}</h2>
          <v-divider></v-divider>
          <div class="day-hours">
            <v-expansion-panels>
              <div
                class="agenda-row"
                v-for="hour in day.hours"
                :key="hour.hour"
              >
                <div v-if="hour.event === undefined">
                  {{ moment(hour.hour).format("HH:mm") }}
                </div>
                <div v-else>
                  <span v-if="hour.event.giornoIntero">Giornata intera</span>
                  <template v-else>
                    <span>
                      {{ moment(hour.event.inizio).format("HH:mm") }} -
                      {{ moment(hour.event.fine).format("HH:mm") }}
                    </span>
                  </template>

                  <template v-if="hour.event.tipo === 'RichiestaPermesso'">
                    <div>
                      <v-btn
                        color="secondary"
                        class=" "
                        @click="openAnnullaDialog(hour.event)"
                      >
                        {{ hour.event.descrizione || "Richiesta di permesso" }}
                      </v-btn>
                    </div>
                  </template>

                  <template v-else>
                    <v-btn
                      v-if="isMobile || showMobileVersion"
                      outlined
                      tile
                      :style="
                        'display:block;text-align: left; border:1px solid;height:auto; width:100% !important;' +
                        (hour.event.tipo === EventType.Intervento
                          ? hour.event.color
                          : '#000') +
                        ';' +
                        'color:' +
                        (hour.event.tipo === EventType.Intervento
                          ? hour.event.color
                          : '#000') +
                        ';'
                      "
                      :key="hour.event.idIntervento"
                      @click="event_Click(hour.event)"
                    >
                      <div>
                        <span
                          style="font-size: 18px; display: inline-block"
                          v-if="hour.event.cliente"
                        >
                          {{ hour.event.cliente.descrizione }}
                        </span>
                        <br />
                        <span>{{ hour.event.descrizione }}</span>
                      </div>
                    </v-btn>

                    <v-expansion-panel
                      @change="expansionPanels_Change(hour, day)"
                      v-if="!isMobile && !showMobileVersion"
                    >
                      <v-expansion-panel-header
                        :style="
                          'text-align: left; border:1px solid ' +
                          (hour.event.tipo === EventType.Intervento
                            ? hour.event.color
                            : '#000') +
                          ';' +
                          'color:' +
                          (hour.event.tipo === EventType.Intervento
                            ? hour.event.color
                            : '#000') +
                          ';'
                        "
                        :key="hour.event.idIntervento"
                        dense
                      >
                        <div>
                          <span
                            style="font-size: 18px; display: inline-block"
                            v-if="hour.event.cliente"
                          >
                            {{ hour.event.cliente.descrizione }} -
                          </span>
                          <span>{{ hour.event.descrizione }}</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <EventInfoModal :evento="hour.event"></EventInfoModal>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>
                </div>
              </div>
              <!-- <div
                v-for="permesso in day.events.filter(e => e.tipo === 'RichiestaPermesso' && e.giornoIntero)"
                :key="permesso.id"
                class="agenda-row"
              >
                <v-btn
                  color="secondary"
                  class="mt-2"
                  @click="openAnnullaDialog(permesso)"
                >
                  {{ permesso.descrizione || 'Richiesta di permesso' }}
                </v-btn>
              </div> -->
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="showEventDetailsModal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dense flat>
          <v-btn icon @click="showEventDetailsModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Dettaglio evento</v-toolbar-title>
        </v-toolbar>

        <v-card-text v-if="event">
          <EventInfoModal :evento="event" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ferieDialog" :persistent="true" max-width="600px">
      <v-card :loading="isCreatingPermissionsRequests">
        <v-card-title class="headline"
          >Seleziona i giorni di ferie</v-card-title
        >
        <v-card-text>
          <div class="ferie-calendar-wrapper">
            <v-date-picker
              v-model="giorniSelezionati"
              :disabled="isCreatingPermissionsRequests"
              multiple
            ></v-date-picker>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="ferieDialog = false"
            :disabled="isCreatingPermissionsRequests"
            >Annulla</v-btn
          >
          <v-btn
            color="primary"
            @click="inviaRichiestaFerie"
            :disabled="isCreatingPermissionsRequests"
            >Conferma</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="annullaDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Annulla richiesta</v-card-title>
        <v-card-text> Vuoi annullare la richiesta? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="annullaDialog = false">No</v-btn>
          <v-btn color="red" text @click="confermaAnnullaRichiesta">Sì</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EasyPlanClient from "@/utils/EasyPlanClient";
import EventInfoModal from "@/components/Planner/EventInfoModal";
import EventType from "@/settings/EventType";
import moment from "moment";
import SessionHelper from "@/utils/SessionHelper";

export default {
  props: {
    showTitle: { default: true, type: Boolean },
    showMobileVersion: { default: false, type: Boolean },
  },
  components: { EventInfoModal },
  data: () => ({
    moment: moment,
    EventType: EventType,
    ferieDialog: false,
    annullaDialog: false,
    richiestaSelezionata: null,
    event: null,

    isCreatingPermissionsRequests: false,
    showEventDetailsModal: false,
    isMobile: false,
    days: [],
    events: [],
    loading: false,
    giorniSelezionati: [],
  }),
  created() {
    this.checkIfIsMobile();
    this.loadEvents(this.event_Loaded);
  },
  computed: {
    orderedDays() {
      return [...this.days].sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
    },
  },
  methods: {
    event_Loaded(data) {
      data = data.sort((e1, e2) => moment(e1.inizio).isBefore(e2.inizio));
      for (let i = 0; i < data.length; i++) {
        let ev = data[i];
        let fdate = moment(ev.inizio).format("DD MMM yyyy");

        let day = this.days.find((d) => d.text == fdate);
        if (!day) {
          day = { text: fdate, date: ev.inizio, events: [], hours: [] };
          this.days.push(day);
        }
        day.events.push(ev);
      }

      let lastEv = null;
      for (let i = 0; i < this.days.length; i++) {
        let day = this.days[i];
        for (let h = 0; h < 24; h++) {
          let hour = ("" + h).padStart(2, "0") + ":00";

          let hourEvent = day.events.find(
            (e) =>
              moment(this.FloorHours(e.inizio)).format("HH:mm") <= hour &&
              moment(this.FloorHours(e.fine)).format("HH:mm") >= hour
          );

          if (lastEv !== hourEvent && hourEvent !== undefined) {
            lastEv = hourEvent;

            day.hours.push({
              hour: this.FloorHours(hourEvent.inizio),
              event: undefined,
            });
            day.hours.push({ hour: hour, event: hourEvent });
            day.hours.push({
              hour: this.RoundHours(hourEvent.fine),
              event: undefined,
            });
          }
        }
      }
    },
    event_Click(event) {
      this.event = event;
      this.showEventDetailsModal = true;
    },
    checkIfIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
    loadEvents(callback = () => {}) {
      this.loading = true;
      EasyPlanClient.Event.FindByCompanyAliasDateFromTo(
        this.$route.params.companyAlias,
        new Date(),
        new Date().setDate(new Date().getDate() + 30),
        true
      )
        .then((res) => {
          this.events = res.data.data;
          callback(res.data.data);
        })
        .catch((error) => {
          console.error("Errore nel caricamento eventi", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    RoundHours(date) {
      let d = new Date(date);
      return d.setMinutes(60);
    },
    FloorHours(date) {
      let d = new Date(date);
      return d.setMinutes(0);
    },
    openAnnullaDialog(evento) {
      this.richiestaSelezionata = evento;
      this.annullaDialog = true;
    },
    confermaAnnullaRichiesta() {
      const alias = this.$route.params.alias || this.$route.params.companyAlias;
      if (!alias || !this.richiestaSelezionata?.idIntervento) {
        console.error("Impossibile annullare la richiesta");
        alert("Impossibile annullare la richiesta");
        return;
      }
      EasyPlanClient.Event.Delete(alias, this.richiestaSelezionata.idIntervento)
        .then(() => {
          this.annullaDialog = false;
          this.days = [];
          this.loadEvents(this.event_Loaded);
        })
        .catch((err) => {
          console.error("Errore durante l'annullamento:", err);
          this.$toast?.error("Errore durante l'annullamento");
        });
    },
    inviaRichiestaFerie() {
      const alias = this.$route.params.alias || this.$route.params.companyAlias;
      const utente = SessionHelper.getCurrentUser();

      if (
        !alias ||
        !utente?.idUtente ||
        !utente?.idAzienda ||
        !utente?.idOperatore
      ) {
        alert("Dati utente incompleti");
        console.error("alias", alias);
        console.error("utente", utente);
        return;
      }

      const eventi = this.giorniSelezionati.map((dataStr) => {
        const inizio = moment(dataStr).startOf("day").add(1, "day").toDate();
        const fine = moment(dataStr).endOf("day").add(1, "day").toDate();
        inizio.setUTCHours(9);
        fine.setUTCHours(18);
        return {
          idAzienda: utente.idAzienda,
          idCreatore: utente.id,
          inizio: inizio.toISOString(),
          fine: fine.toISOString(),
          giornoIntero: true,
          tipo: "RichiestaPermesso",
          descrizione: "Richiesta ferie da calendario",
          note: "",
          rimosso: false,
          risorse: [{ idRisorsa: utente.idOperatore }],
          risorseIntervento: [{ idRisorsa: utente.idOperatore }],
        };
      });
      this.isCreatingPermissionsRequests = true;
      Promise.all(
        eventi.map((evento) => EasyPlanClient.Event.Insert(alias, evento))
      )
        .then(() => {
          this.ferieDialog = false;
          this.loading = true;
          this.$toast?.success("Richieste inviate con successo");
          this.isCreatingPermissionsRequests = false;
          this.ferieDialog = false;
          this.giorniSelezionati = [];
          this.days = [];
          this.loadEvents(this.event_Loaded);
        })
        .catch((err) => {
          console.error("Errore durante l'invio:", err);
          this.$toast?.error("Errore durante l'invio");
        })
        .finally(() => {
          this.loading = false;
          this.isCreatingPermissionsRequests = false;
        });
    },
  },
};
</script>

<style scoped>
.agenda-viewer {
  overflow: hidden;
  overflow-y: auto;
  padding-bottom: 20px;
}

.day {
  margin-top: 20px;
  margin-bottom: 20px;
}

.agenda-row {
  display: block;
  border-bottom: 1px solid #eee;
  min-height: 22px;
  width: 100%;
}

.day-text {
  margin-top: 15px;
}

.ferie-calendar-wrapper {
  display: flex;
  justify-content: center;
}
</style>
